import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { TokenService } from '../core/token/token.service';

@Injectable({
  providedIn: 'root'
})
export class PerfilService {
  private apiUrl = environment.apiGestorUrlLocal;
  httpOptions = {
    headers: new HttpHeaders({ 'Content-Type': 'application/json', 'authorization': this.tokenService.getToken(), 'session': this.tokenService.getSessionUsuario() }),
    params: {}
  };

  constructor(private http: HttpClient, private tokenService: TokenService) { }

  getListagemPerfis(params, filtros): Observable<any> {
    this.httpOptions.params = params;
    return this.http.post(`${this.apiUrl}api/perfis/list`, filtros, this.httpOptions)
      .pipe(
        catchError(this.handleError)
      );
  }

  createPerfil(payload): Observable<any> {
    this.httpOptions.params = "";
    return this.http.post(`${this.apiUrl}api/perfis`, payload, this.httpOptions)
      .pipe(
        catchError(this.handleError)
      );
  }

  updatePerfil(payload): Observable<any> {
    this.httpOptions.params = "";
    return this.http.put(`${this.apiUrl}api/perfis`, payload, this.httpOptions)
      .pipe(
        catchError(this.handleError)
      );
  }

  deletePerfil(id): Observable<any> {
    this.httpOptions.params = "";
    return this.http.delete(`${this.apiUrl}api/perfis/${id}`, this.httpOptions)
      .pipe(
        catchError(this.handleError)
      );
  }

  getPerfis(): Observable<any> {
    this.httpOptions.params = '';
    return this.http.get(`${this.apiUrl}api/perfis/dropdownlist`, this.httpOptions)
      .pipe(
        catchError(this.handleError)
      );
  }

  getPermissoesPerfilTree(filtro): Observable<any> {
    this.httpOptions.params = "";
    return this.http.get(`${this.apiUrl}api/perfis/permissoes/${filtro}`, this.httpOptions)
      .pipe(
        catchError(this.handleError)
      );
  }

  atualizaPermissoesPerfil(perfil_id, funcoes): Observable<any> {
    this.httpOptions.params = "";
    return this.http.put(`${this.apiUrl}api/perfis/permissoes/${perfil_id}`, funcoes, this.httpOptions)
      .pipe(
        catchError(this.handleError)
      );
  }

  private handleError(error: HttpErrorResponse) {
    if (error.error instanceof ErrorEvent) {
      console.error('Ops! Ocorreu um erro:', error.error);
    } else {
      console.error(
        `Backend retornou o código ${error.status}, ` +
        `o body é:`, error);
    }
    return throwError(
      error.error);
  }
}
